var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1616_38033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6685 42.126H49.9443C50.4204 42.126 50.8064 41.74 50.8064 41.2639V10.2295C50.8064 9.7534 50.4204 9.36736 49.9443 9.36736H1.6685C1.19243 9.36746 0.806396 9.7534 0.806396 10.2295V41.2639C0.806396 41.7401 1.19243 42.126 1.6685 42.126Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8063 16.2643H0.806396V35.2301H50.8063V16.2643Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9269 25.7467L22.6578 22.4576C22.7252 22.1547 22.4946 21.8674 22.1843 21.8674H21.6694C21.3592 21.8674 21.1287 22.1547 21.1959 22.4576L21.9269 25.7467Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7891 24.0221H21.0649V31.3493H22.7891V24.0221Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2194 23.1608H20.6332V24.0229H23.2194V23.1608Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2218 25.7467H18.9113V26.6088H23.2218V25.7467Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2217 29.1949L20.6355 28.3329V27.4708L23.2217 28.3329V29.1949Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99755 25.7467L9.7285 22.4575C9.79588 22.1546 9.56532 21.8673 9.25497 21.8673H8.74013C8.42987 21.8673 8.1994 22.1546 8.26659 22.4575L8.99755 25.7467Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0135 23.1605C11.5374 23.1605 11.1514 23.5466 11.1514 24.0226V29.626C11.1514 30.6734 12.1289 32.6433 15.4617 32.6433C18.7945 32.6433 19.7721 30.6735 19.7721 29.626V24.0226C19.7721 23.5466 19.386 23.1605 18.9099 23.1605H12.0135Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4629 27.4708H11.1526V24.0226C11.1526 23.5465 11.5386 23.1604 12.0147 23.1604H15.4629V27.4708Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.463 27.4708H19.7734V29.626C19.7734 30.8163 18.8085 31.7811 17.6182 31.7811C16.4279 31.7811 15.463 30.8163 15.463 29.626V27.4708Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1514 27.4709H15.4617V29.626C15.4617 30.8164 14.4969 31.7812 13.3065 31.7812C12.1162 31.7812 11.1514 30.8164 11.1514 29.626V27.4709Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5978 31.3405V27.4709H13.7357V31.7378C14.0564 31.6727 14.3462 31.5307 14.5978 31.3405Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 31.7378V27.4709H12.0116V31.3405C12.2634 31.5307 12.5531 31.6727 12.8737 31.7378Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5997 25.7468H12.0134V26.6089H14.5997V25.7468Z",
    fill: "#FFB441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5997 24.0221H12.0134V24.8842H14.5997V24.0221Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1676 24.5349H12.4435V26.0966H14.1676V24.5349Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85742 24.0221H8.1333V31.3493H9.85742V24.0221Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2872 30.9195H7.70093V31.7817H10.2872V30.9195Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2872 23.1608H7.70093V24.0229H10.2872V23.1608Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7205 31.7809H7.27222V32.643H10.7205V31.7809Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6512 30.9196H21.0649V31.7817H23.6512V30.9196Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6508 31.7809H20.2025V32.643H23.6508V31.7809Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0479 22.2985H12.8755V23.1606H18.0479V22.2985Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.893 19.7126H15.0309V22.2988H15.893V19.7126Z",
    fill: "#FFB441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5993 21.0054C13.8863 21.0054 13.3063 20.4253 13.3063 19.7123C13.3063 18.9992 13.8864 18.4192 14.5993 18.4192C15.3124 18.4192 15.8924 18.9993 15.8924 19.7123C15.8925 20.4253 15.3124 21.0054 14.5993 21.0054ZM14.5993 19.2813C14.3615 19.2813 14.1683 19.4744 14.1683 19.7123C14.1683 19.9501 14.3614 20.1434 14.5993 20.1434C14.8372 20.1434 15.0304 19.9502 15.0304 19.7123C15.0304 19.4745 14.8372 19.2813 14.5993 19.2813Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3235 21.0054C15.6104 21.0054 15.0304 20.4253 15.0304 19.7123C15.0304 18.9992 15.6105 18.4192 16.3235 18.4192C17.0365 18.4192 17.6165 18.9993 17.6165 19.7123C17.6165 20.4253 17.0364 21.0054 16.3235 21.0054ZM16.3235 19.2813C16.0857 19.2813 15.8924 19.4744 15.8924 19.7123C15.8924 19.9501 16.0856 20.1434 16.3235 20.1434C16.5613 20.1434 16.7545 19.9502 16.7545 19.7123C16.7544 19.4745 16.5613 19.2813 16.3235 19.2813Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0478 21.8675C17.3347 21.8675 16.7548 21.2874 16.7548 20.5744C16.7548 19.8613 17.3348 19.2814 18.0478 19.2814C18.7609 19.2814 19.3409 19.8614 19.3409 20.5744C19.3409 21.2874 18.7608 21.8675 18.0478 21.8675ZM18.0478 20.1434C17.81 20.1434 17.6168 20.3365 17.6168 20.5744C17.6168 20.8122 17.8099 21.0055 18.0478 21.0055C18.2856 21.0055 18.4789 20.8123 18.4789 20.5744C18.4789 20.3365 18.2856 20.1434 18.0478 20.1434Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8752 21.8675C12.1621 21.8675 11.5822 21.2874 11.5822 20.5744C11.5822 19.8613 12.1622 19.2814 12.8752 19.2814C13.5883 19.2814 14.1683 19.8614 14.1683 20.5744C14.1684 21.2874 13.5883 21.8675 12.8752 21.8675ZM12.8752 20.1434C12.6374 20.1434 12.4442 20.3365 12.4442 20.5744C12.4442 20.8122 12.6373 21.0055 12.8752 21.0055C13.1131 21.0055 13.3063 20.8122 13.3063 20.5743C13.3063 20.3365 13.1131 20.1434 12.8752 20.1434Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0475 29.195V29.626C18.0475 29.8637 17.8541 30.0571 17.6164 30.0571C17.3787 30.0571 17.1854 29.8637 17.1854 29.626V29.195H18.0475ZM18.9095 28.333H16.3232V29.626C16.3232 30.3391 16.9033 30.9191 17.6163 30.9191C18.3294 30.9191 18.9094 30.339 18.9094 29.626V28.333H18.9095Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6169 26.6088C17.1408 26.6088 16.7548 26.2228 16.7548 25.7467V24.8846C16.7548 24.4085 17.1408 24.0225 17.6169 24.0225C18.0929 24.0225 18.479 24.4085 18.479 24.8846V25.7467C18.479 26.2228 18.0929 26.6088 17.6169 26.6088Z",
    fill: "#FFA0D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4615 28.7634C16.1757 28.7634 16.7546 28.1845 16.7546 27.4704C16.7546 26.7562 16.1757 26.1773 15.4615 26.1773C14.7474 26.1773 14.1685 26.7562 14.1685 27.4704C14.1685 28.1845 14.7474 28.7634 15.4615 28.7634Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.893 17.988H15.0309V20.5742H15.893V17.988Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8749 22.2985L12.0128 21.4364L12.5178 20.9314C13.2984 20.1508 14.3571 19.7123 15.4612 19.7123C16.5652 19.7123 17.6238 20.1508 18.4045 20.9314L18.9095 21.4364L18.0474 22.2985H12.8749Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4604 21.8672C15.6984 21.8672 15.8914 21.6742 15.8914 21.4361C15.8914 21.198 15.6984 21.005 15.4604 21.005C15.2223 21.005 15.0293 21.198 15.0293 21.4361C15.0293 21.6742 15.2223 21.8672 15.4604 21.8672Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7357 21.8672C13.9738 21.8672 14.1668 21.6742 14.1668 21.4361C14.1668 21.198 13.9738 21.005 13.7357 21.005C13.4977 21.005 13.3047 21.198 13.3047 21.4361C13.3047 21.6742 13.4977 21.8672 13.7357 21.8672Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.184 21.8672C17.422 21.8672 17.615 21.6742 17.615 21.4361C17.615 21.198 17.422 21.005 17.184 21.005C16.9459 21.005 16.7529 21.198 16.7529 21.4361C16.7529 21.6742 16.9459 21.8672 17.184 21.8672Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0115 25.7468H7.70093V26.6089H12.0115V25.7468Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70093 29.195L10.2871 28.333V27.4709L7.70093 28.333V29.195Z",
    fill: "#C8414B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1616_38033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.804688 0.746582)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.dc2106f9fac0e9418cd8760dc3dda305.svg";
export { ForwardRef as ReactComponent };